import { Component } from '@angular/core';

import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { MockServices } from 'src/app/Services/Mock-data/mock.service';
import { ChangeDataService } from 'src/app/Services/ChangeData/changeData.service';
import { delay } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/Api/api.service';
import { CurrencyPipe } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import localeCo from '@angular/common/locales/es-CO';
registerLocaleData(localeCo, 'co');

@Component({
  selector: 'app-tarifas',
  templateUrl: './tarifas.component.html',
  styleUrls: ['./tarifas.component.css'],
})
export class TarifasComponent {
  index = 0;
  cargando = true;

  currencyPipe = new CurrencyPipe('co', 'COP');

  //Headers Table
  headers: any[] = [
    { titulo: 'Categoría', porcentaje: '83%' },
    { titulo: 'Valor', porcentaje: '17%' },
  ];
  subtitle =
    'Consulta aquí toda la información acerca del costo de las tarifas del peaje';
  dataTarifa2: any[] = [];

  newData: any[] = [];

  numData: any;

  inputText = 'Buscar tarifas';
  constructor(
    private breakpointObserver: BreakpointObserver,
    private mService: MockServices,
    private changeDataService: ChangeDataService,
    private _apiService: ApiService
  ) {
    _apiService.get('tabla-tipo/Tarifa').then((data) => {
      this.sidebarLinks = [
        ...data.tablaTipo.map((tarifa: any) => ({
          id: tarifa.id,
          decorator: false,
          icon: tarifa.icono,
          tittle: tarifa.nombre,
        })),
      ] ?? [{}];
      if (data.tablaTipo.length === 0) {
        this.cargando = false;
      }
      this.changeDataService.onChangeTittle(this.sidebarLinks[0]!!.tittle);
      this.selectNewRecords(this.sidebarLinks[0].id);
    });
    this.changeDataService.onChangedIndex$.pipe(delay(0)).subscribe((x) => {
      this.selectNewRecords(x);
    });

    this.changeDataService.onChangedTittle$.pipe(delay(0)).subscribe((x) => {
      this.links[1] = x;
    });
  }

  private selectNewRecords(x: any) {
    this._apiService.get('tarifa/' + x).then((data) => {
      this.index = x;
      this.dataTarifa2 = this.newData = [
        ...data.tarifas.map((tarifa: any) => [
          tarifa.tramite,
          this.currencyPipe.transform(
            tarifa.valor,
            undefined,
            undefined,
            '1.0'
          ),
        ]),
      ] ?? [[]];
      this.cargando = false;
    });
  }

  showFiller = false;
  sidebarLinks: any = [];

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );

  changeData(e: Event) {
    var target = (e.currentTarget as Element).id;
  }

  links = ['Tarifas ', ''];

  onResult(data: any) {
    this.newData = data;
  }
}
